import { render, staticRenderFns } from "./OtherMethodTab.vue?vue&type=template&id=0f0dcf75&scoped=true"
import script from "./OtherMethodTab.vue?vue&type=script&lang=js"
export * from "./OtherMethodTab.vue?vue&type=script&lang=js"
import style0 from "./OtherMethodTab.vue?vue&type=style&index=0&id=0f0dcf75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0dcf75",
  null
  
)

export default component.exports